{
  class inlinePagination extends HTMLElement {

    connectedCallback() {
      //initialize data
      this.perPage = this.hasAttribute('items-per-page') ? parseInt(this.getAttribute('items-per-page')) : 4
      this.page = 1
      this.maxPages = 1
      this.itemsSelector = this.hasAttribute('items-selector') ? this.getAttribute('items-selector') : null
      this.prevNextStyle = this.hasAttribute('prev-next-style') ? this.getAttribute('prev-next-style') : 'disable' //if this is anything other than `disable` it will hide them instead
      this.items = []

      //set up real data
      if(this.itemsSelector){
        this.items = document.querySelectorAll(this.itemsSelector)
        if(this.items.length){
          this.maxPages = Math.ceil(this.items.length / this.perPage)
          if(this.maxPages == 1){
            this.remove()
          } else {
            this._updateVisibleItems()
          }
        }
      }

      if(this.hasAttribute('initial-page')){  
        this.goToPage(parseInt(this.getAttribute('initial-page')))
      }
    }

    _updateVisibleItems(shouldFocus = false){
        let minIndex = (this.page - 1) * this.perPage
        let maxIndex = (this.page * this.perPage) - 1
        let prev = this.querySelector('button[is="inline-pagination-prev"]')
        let next = this.querySelector('button[is="inline-pagination-next"]')
        let pageButtons = Array.from(this.querySelectorAll(`[aria-label^="Go to page "]`))
        let useLoadMore = this.hasAttribute('load-more') && this.getAttribute('load-more') == 'true'
        let activePageClass = this.hasAttribute('active-page-class') ? this.getAttribute('active-page-class') : 'active'

        for(let i = 0; i < this.items.length; i++){
        if(useLoadMore){
            if(i <= maxIndex){
            this._showItem(i)
            } else {
            this._hideItem(i)
            }
        } else {
            if(i >= minIndex && i <= maxIndex){
            this._showItem(i)
            } else {
            this._hideItem(i)
            }
        }
        }

        if(prev){
        if(this.page == 1){
            if(this.prevNextStyle == 'disable'){
            prev.setAttribute('disabled', true)
            } else {
            prev.style.display = 'none'
            }
        } else {
            if(this.prevNextStyle == 'disable'){
            prev.removeAttribute('disabled')
            } else {
            prev.style.display = ''
            }
        }
        }

        if(next){
        if(this.page == this.maxPages){
            if(this.prevNextStyle == 'disable'){
            next.setAttribute('disabled', true)
            } else {
            next.style.display = 'none'
            }
        } else {
            if(this.prevNextStyle == 'disable'){
            next.removeAttribute('disabled')
            } else {
            next.style.display = ''
            }
        }
        }

        if(pageButtons.length){
        pageButtons.forEach(p => {
            p.classList.remove(activePageClass)
            p.setAttribute('aria-current', false)
        })
        pageButtons[this.page - 1].classList.add(activePageClass)
        pageButtons[this.page - 1].setAttribute('aria-current', true)
        }

        if(shouldFocus){
        setTimeout(() => {
            this.items[minIndex].setAttribute('tabindex', -1)
            this.items[minIndex].focus()
        })
        }
    }

    _showItem(i){
        this.items[i].style.display = ''
    }

    _hideItem(i){
        this.items[i].style.display = 'none'
    }

    insertAfter(newNode, existingNode) {
      existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    }


    goToPrevPage(){
      if(this.page > 1){
        this.page -= 1
        this._updateVisibleItems(true)
      }
    }

    goToNextPage(){
      if(this.page != this.maxPages){
        this.page += 1
        this._updateVisibleItems(true)
      }
    }

    goToPage(i){
      if(this.page != i){
        this.page = i
        this._updateVisibleItems(true)
        }
      }
    }

    class inlinePaginationPrev extends HTMLButtonElement {
      constructor() {
        super()
        if(!this.hasAttribute('aria-label')){
        this.setAttribute('aria-label', 'Go To Previous page')
        }
        this.addEventListener('click', () => this.parentNode.goToPrevPage())
      }
    }

    class inlinePaginationNext extends HTMLButtonElement {
      constructor() {
        super()

        if(!this.hasAttribute('aria-label')){
        this.setAttribute('aria-label', 'Go To Next page')
        }

        this.addEventListener('click', () => this.parentNode.goToNextPage())
      }
    }

    class inlinePaginationPage extends HTMLButtonElement {
      connectedCallback() {
        setTimeout(() => {
          const parent = this.closest('inline-pagination')
          let prevButton = this
          for(let i = 1; i <= parent.maxPages; i++){
            const button = document.createElement('button')
            button.classList.add(this.classList)
            button.setAttribute('aria-label', `Go to page ${i}`)
            button.innerHTML = this.innerHTML.replaceAll("${i}", i)
            button.addEventListener('click', () => parent.goToPage(i))
            prevButton.after(button)
            prevButton = button
          }
          this.style.display = "none"
          parent._updateVisibleItems()
        })
      }
    }

  customElements.define('inline-pagination', inlinePagination)
  customElements.define('inline-pagination-prev', inlinePaginationPrev, { extends: 'button' })
  customElements.define('inline-pagination-next', inlinePaginationNext, { extends: 'button' })
  customElements.define('inline-pagination-page', inlinePaginationPage, { extends: 'button' })
}